
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/addPanelInfra/newAddPanel/components/logo/logoSection.scss.css.virtualfile';
        module.exports = {"illustration":"_illustration_brstp_1"};